import styled, { css } from 'styled-components'
import { Button, ButtonInnerContainer } from 'components/atoms/Button'
import { RadioButton } from 'components/atoms/RadioButton'
import { RadioButtonInput } from 'components/atoms/RadioButton/RadioButton'
import { ReactNode } from 'react'
import { Tooltip } from 'components/atoms/Tooltip'
import { QuestionIcon } from 'components/atoms/Icons'

export interface RadioTileProps {
  title: string
  disabled?: boolean
  description?: string
  selected?: boolean
  onClick: () => void
  className?: string
  tooltip?: ReactNode
}

export const RadioTile = ({
  className,
  disabled,
  title,
  description,
  onClick,
  selected = false,
  tooltip,
}: RadioTileProps) => {
  return (
    <StyledRadioButton disabled={disabled} type="button" onClick={onClick} selected={selected} className={className}>
      <ButtonInner>
        <Title>
          <RadioButton disabled={disabled} name={title} checked={selected} value={title} scale="large">
            {title}
          </RadioButton>
          {!!tooltip && (
            <Tooltip tooltip={tooltip}>
              <QuestionIcon />
            </Tooltip>
          )}
        </Title>
        {!!description && <Description>{description}</Description>}
      </ButtonInner>
    </StyledRadioButton>
  )
}

const StyledRadioButton = styled(Button)<Pick<RadioTileProps, 'selected'>>`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.Mouse};
  padding: 32px 24px;
  color: ${({ theme }) => theme.colors.Text03};
  min-width: unset;
  height: unset;
  align-items: flex-start;

  ${ButtonInnerContainer} {
    width: 100%;
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: ${({ theme }) => theme.colors.HeavyMetal};
    `}
  &:hover {
    text-decoration: none;

    &:not(:disabled) {
      color: initial;
      border-color: ${({ theme }) => theme.colors.HeavyMetal};

      ${RadioButtonInput} {
        border-color: ${({ disabled, theme }) => (disabled ? theme.colors.Mouse : theme.colors.HeavyMetal)};
      }
    }
  }

  @media ${({ theme }) => theme.queries.mobileAndSmaller} {
    width: 100%;
  }
`

const ButtonInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`

const Description = styled.div`
  color: ${({ theme }) => theme.colors.Text01};
  width: 100%;
  word-break: break-word;
  white-space: normal;
  text-align: left;
  font-size: 14px;
`

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
